module.exports = __webpack_public_path__ + "assets/img/z3.45123851.png";